import LinkTab from '../components/shared-components/link_tab';
import {Tooltip} from "@mui/material";
import { connect } from 'react-redux';
import { setInfo, setGameData } from '../redux/actionList';

import CommentModal from '../components/shared-components/comment_modal';
import SkillsInterestsInput from '../components/getting-started/skills_interests_input';
import HomeSelect from '../components/getting-started/home_select';
import CarSelect from '../components/getting-started/car_select';
import CareerSelect from '../components/getting-started/career_select';
import FurnitureInput from '../components/getting-started/furniture_input';
import FinalConfirmModal from '../components/getting-started/final_confirm_modal';
import {InputCompletedContext} from '../objects/Context/input_completed_context';
import {ModalContext} from '../objects/Context/modal_context';
import { setupConditionsUpdate } from '../components/game-views/objects/set_up_conditions_update_function';
import React from 'react';
import { Link } from "react-router-dom";
import { setHeadersForFetch } from '../objects/CommonUse/set_headers_for_fetch';
import DataObjectsTemplate from '../datasets/data_object_templates';
import ConfigFile from '../datasets/config_file';
import Footer from './footer';
import { getCurrentDateTime } from '../objects/CommonUse/get_current_date_time';
import WaitTimeSpinner from '../components/shared-components/wait_time_spinner';
import {buildUrl } from '../objects/CommonUse/build_URL';
import Config from '../config';
import easyGameChoiceData from '../components/getting-started/datasets/easy_game_choice_data';
import midGameChoiceData from '../components/getting-started/datasets/mid_game_choice_data';
import difficultGameChoiceData from '../components/getting-started/datasets/difficult_game_choice_data';
import getExtraCreditForNewGame from '../objects/AssetsExpenses/get_extra_credit_for_new_game';
import getBadgesEarnedForNewGame from '../objects/AssetsExpenses/get_badges_earned_for_new_game';
import veryDifficultGameChoiceData from '../components/getting-started/datasets/very_difficult_game_choice_data';
import unlockedFeaturesEnabledGameData from '../components/getting-started/datasets/unlocked_features_enabled_data';
import tooltipCommentIconText from './Text/tooltip_text';
import withRouterCompat from '../objects/CommonUse/with_router_compat';
import { rollBackwardDate } from '../components/game-views/objects/roll_backward_date_function';
import checkIfTestComplete from '../objects/CommonUse/check_if_test_complete';
import updateGamePurchaseArr from '../components/game-views/objects/update_game_purchase_arr';


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameInfo: state,
    accountSettings: state.accountSettings,
    moneyMgmtTestArr: state.moneyMgmtTestArr,
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
    setGameDataRedux: setGameData
};

class GettingStartedDetailed extends React.Component {
    constructor(props) {
        super(props);
    
        this.prevIndex = 0;
        this.openCommentModal = this.openCommentModal.bind(this);
        this.closeCommentModal = this.closeCommentModal.bind(this);

        this.state = {
            inputArr: [
                {
                    completed: false,
                    selected: false
                },
                {
                    completed: false,
                    selected: false
                },
                {
                    completed: false,
                    selected: false
                },
                {
                    completed: false,
                    selected: false
                },
                {
                    completed: false,
                    selected: false
                },
                {
                    completed: false,
                    selected: false
                }
            ],
            commentIcon: "./assets/ContactUs/pencilPaper.png",
            commentModalOpen: false,
            fromProcessName: "GettingStarted",
            modalOpen: false,
            loading: true,
            archivedLoading: true,
            extraCreditLoaded: false,
            data: [],
            headers: setHeadersForFetch(),
            screenSize: sessionStorage.getItem("GameScreenSize"),
            environment: Config.dataURL.currentEnv,
            subProcess: "GettingStartedDetailed",
            timeout: 0,
        };

        switch(props.selected) {
            case "skillsInterests":
                this.inputSelected(0);
                break;
            case "chooseCareer":
                this.inputSelected(1);
                break;
            case "chooseHome":
                this.inputSelected(2);
                break;
            case "chooseFurniture":
                this.inputSelected(3);
                break;
            case "chooseCar":
                this.inputSelected(4);
                break;
            default:
                break;
        }
        this.conditionsList = null;
        this.archivedGameData = null;
        this.extraCreditData = null;
        this.checkUserInput();
        this.loadExtraCredit();
        this.startNbrGameMonths = ConfigFile.gameStartItems.totalNbrGameMonths;
      }

    onNavigate = (path) => {
        const { navigate, location } = this.props;
        const targetPath = `/${path}`;
        // Only navigate if we aren’t already there
        if (location.pathname !== targetPath) {
            navigate(`/${path}`, { replace: true });
        }
    };
 
    render() {
        // top-level logic before JSX
       
    return <>
            {this.state.archivedLoading ?
               <WaitTimeSpinner/>
            :
            <span className="container m-0 p-0">
                <span className="row w-100 my-modal-grid">
                    <div className="col-sm-2 mt-4 text-center">
                        <div className="mt-2">
                            <img className="worker-img" src={'./assets/businessPerson.png'} alt="Bus Person"/>
                            <img className="worker-img" src={'./assets/constructionWorker.png'} alt="Construction Worker"/>
                        </div>
                        <div className="mt-2">
                            <img className="worker-img" src={'./assets/doctor.png'}  alt="Doctor"/>
                            <img className="worker-img" src={'./assets/chef.png'} alt="Chef"/>
                        </div>
                        <div className="mt-2">
                            <img className="worker-img" src={'./assets/worker.png'} alt="Worker"/>
                            <img className="worker-img" src={'./assets/policeOfficer.png'} alt="Police"/>
                        </div>
                    </div>
                    <InputCompletedContext.Provider value={this.state}>
                        <div>
                            <Tooltip title={tooltipCommentIconText} arrow >
                                <img src={this.state.commentIcon} 
                                    className="gettingStarted-comment-icon-position comment-img cursor-is-pointer" 
                                    alt="comment"
                                    onClick={this.openCommentModal}/>
                            </Tooltip>
                        </div> 

                        {this.state.commentModalOpen ?
                            <CommentModal modalOpen={this.state.commentModalOpen} 
                                onClose={() => this.closeCommentModal()}
                                gamePart={this.state.fromProcessName}
                                processName={this.props.selected}
                                gameInfo = {() => this.getGameInfo()}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                            />
                        :
                            null
                        }

                        {this.state.inputArr[1].completed &&
                            this.state.inputArr[2].completed &&
                            this.state.inputArr[3].completed &&
                            this.state.inputArr[4].completed  ?
                           <ModalContext.Provider value={this.state}>
                               {this.state.modalOpen === true ?
                                <FinalConfirmModal modalOpen={this.state.modalOpen} 
                                    extraCreditData={this.extraCreditData}
                                    badgesEarned={this.badgesEarnedArr}
                                    onClose={() => this.toggleFinalModal()} 
                                    onSave={() => this.finalizeOptions()}
                                    setExtraCredit={() => this.setExtraCreditEarned()}
                                    processError = {(errorObj) => this.processErrorReturn(errorObj)}
                                   />
                                :
                                <span/>
                               }
                           </ModalContext.Provider>
                        :
                            <p></p>
                        }
                        {this.props.selected === "skillsInterests" ? 
                            <SkillsInterestsInput 
                                nbrGames={this.totalNbrGames}
                                goBack = {() => this.goToHomePage()}
                                completed={() => this.inputCompleted(0)}
                                onOpen ={()=> this.inputSelected(0)}
                                skillSurvey = {this.skillSurvey}
                                createGame = {(templateName) => this.createGameFromTemplate(templateName)}
                                onGameSelected = {(gameID) => this.restoreGame(gameID)}
                                onNavigate={(pathname) => this.onNavigate(pathname)}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}/>
                            :
                            <span/>}
                        {this.props.selected === "chooseCareer" ? 
                            <CareerSelect
                                completed={() => this.inputCompleted(1)}
                                onOpen ={()=> this.inputSelected(1)}
                                onNavigate={(pathname) => this.onNavigate(pathname)}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                                /> : <span/>}
                        {this.props.selected === "chooseHome" ? 
                            <HomeSelect 
                                completed={() => this.inputCompleted(2)}
                                onOpen ={()=> this.inputSelected(2)}
                                onNavigate={(pathname) => this.onNavigate(pathname)}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                                /> : <span/>}
                        {this.props.selected === "chooseFurniture" ?
                             <FurnitureInput 
                                completed={() => this.inputCompleted(3)}
                                onOpen ={()=> this.inputSelected(3)}
                                onNavigate={(pathname) => this.onNavigate(pathname)}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                                /> : <span/>}
                        {this.props.selected === "chooseCar" ? 
                            <CarSelect 
                                completed={() => this.inputCompleted(4)}
                                onOpen ={()=> this.inputSelected(4)}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                                /> : <span/>}

                    
                        <div className="col-sm-2">
                            <Link to="/skills-interests" onClick={() => this.handleClick(0)}>
                                <LinkTab  inputArr={this.state.inputArr[0]} name="Skills / Interests" validToComplete="true"
                                    />
                            </Link>
                            {this.state.inputArr[0].completed ?
                                <Link to="/choose-career" onClick={() => this.handleClick(1)}>
                                    <LinkTab inputArr={this.state.inputArr[1]} name="Choose a Job" validToComplete="true"
                                        />
                                </Link>
                                :
                                <LinkTab inputArr={this.state.inputArr[1]} name="Choose a Job" />
                            }
                            {this.state.inputArr[1].completed ?
                                <Link to="/choose-home" onClick={() => this.handleClick(2)}>
                                    <LinkTab  inputArr={this.state.inputArr[2]} name="Choose a Home" validToComplete="true"
                                        />
                                </Link>
                                :
                                <LinkTab  inputArr={this.state.inputArr[2]} name="Choose a Home" />
                            }
                            {this.state.inputArr[1].completed ?
                                <Link to="/choose-furniture" onClick={() => this.handleClick(3)}>
                                    <LinkTab inputArr={this.state.inputArr[3]} name="Choose Furniture" validToComplete="true"
                                    />
                                </Link>
                                :
                                <LinkTab inputArr={this.state.inputArr[3]} name="Choose Furniture" />
                            }
                            {this.state.inputArr[1].completed ?
                                <Link to="/choose-car" onClick={() => this.handleClick(4)}>
                                    <LinkTab inputArr={this.state.inputArr[4]} name="Choose a Car" validToComplete="true"
                                    />
                                </Link>
                                :
                                <LinkTab inputArr={this.state.inputArr[4]} name="Choose a Car" />
                            }
                            {this.state.inputArr[1].completed &&
                            this.state.inputArr[2].completed &&
                            this.state.inputArr[3].completed &&
                            this.state.inputArr[4].completed  ?
                            <Link to="#" onClick={() => this.toggleFinalModal()}>
                                <LinkTab inputArr={this.state.inputArr[5]} name="Play the Game" validToComplete="true"
                                />
                            </Link>
                            :
                            <LinkTab inputArr={this.state.inputArr[5]} name="Play the Game"/>
                            }
                            {( this.state.screenSize === "zoom") &&
                                <Footer 
                                    screenSize={this.state.screenSize}
                                />
                            }
                        </div>
                    </InputCompletedContext.Provider>
                </span>
        {/*
                 {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
        */}
            </span>
            }
        </>
    }

    componentDidMount(){
        this._isMounted = true;
        this.loadConditions();
        this.getArchivedGameData();
        this.inputSelected(0);
    }
   
    inputSelected = (inputID) => {
        let inputArr = this.state.inputArr;
        for (const input of inputArr) {
            input.selected = false;
        }
        inputArr[inputID].selected = true;
        if (this._isMounted === true){
            this.setState({inputArr: inputArr});
        }
    };
                        
    inputCompleted = (inputID) => {
        let inputArr = this.state.inputArr;
        inputArr[inputID].completed = true;
        this.setState({inputArr: inputArr});
        if(inputID === 4)
        {
            this.toggleFinalModal();
        }
    };

    loadConditions()
    {
        const funcName = "eventConditionsList";
        const urlParm = "?triggeredByList=gameStart,jobChange,homeChange,carChange";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        if (output.body != null) {
                            this.conditionsList = output.body;
                        }
                        if (this._isMounted === true){
                            this.setState({loading: false});
                        }
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
    }
    
    getArchivedGameData()
    {
        const funcName = "archivedGameData";
        const totalGameMonths = ConfigFile.gameStartItems.totalNbrGameMonths;
        const urlParm = "?totalGameMonths=" + +totalGameMonths + "&rqstType=CountOfGames";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.skillSurvey = output.body.skillSurvey;
                        this.totalNbrGames = output.body.nbrGames;
                        this.totalPrevGameMonths = output.body.totalNbrGameMonths;
                        if (!output.body.badgesEarned){
                            this.badgesEarnedArr = [];
                        }else{
                            this.badgesEarnedArr = output.body.badgesEarned;
                        }
                        if (this._isMounted === true){
                            this.setState({archivedLoading: false});
                        }
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
    }

    loadExtraCredit()
    {
        const funcName = "loadExtraCreditInfo";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200 || statusCode === 250){
                        this.extraCreditData = output.body;
                        this.setState({extraCreditLoaded: true});
                    }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.processErrorReturn(errorObj);
                    }
                });
            };
        });
    }

    getGameInfo(){
        return {process: "Getting Started Info"};
    }
    
    openCommentModal(){
        this.setState({commentModalOpen: true});
    }

    closeCommentModal(){
        this.setState({commentModalOpen: false});
    }

    handleClick = index => {
        this.inputSelected(index);
    }

    toggleFinalModal() {
        for (let i = 0; i < this.state.inputArr.length; ++i) {
            if (this.state.inputArr[i].selected === true && i !== 5)
            {
                this.prevIndex = i;
                break;
            }
        }
        this.setState({modalOpen: !this.state.modalOpen});
        if (this.state.modalOpen === false) this.inputSelected(5);
        else this.inputSelected(this.prevIndex);
    }

    createGameFromTemplate(templateName){
        let gameTemplate = {};
        switch (templateName){
            case "easyGame":
                gameTemplate = easyGameChoiceData;
                break;
            case "midGame":
                gameTemplate = midGameChoiceData;
                break;
            case "difficultGame":
                gameTemplate = difficultGameChoiceData;
                break;
            case "veryDifficultGame":
                gameTemplate = veryDifficultGameChoiceData;
                break;
             case "unlockedFeaturesEnabled":
                gameTemplate = unlockedFeaturesEnabledGameData;
                break;
            default:
                break;
        }
        this.setCurrentYYYYMM();
        this.determineBodyObj(gameTemplate);
        this.createGamesCollection();
    }

    setCurrentYYYYMM(){
        var today = new Date();
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        this.currentYYYYMM = `${yyyy}-${mm}`;
    }
    
    determineBodyObj(gameTemplate){
        const username = sessionStorage.getItem("username");
        this.currentCash = +gameTemplate.currentCash;
        this.addExtraCreditAndBadges(gameTemplate.assetTable);
        if (this.allExtraCreditEarned === true){
            this.createNewCondition(gameTemplate.conditionsTable);
        }
        this.currentCash = this.currentCash.toString();
        let carInfo = gameTemplate.carInfo;
        carInfo.carGameDate = this.currentYYYYMM;
        let jobInfo = gameTemplate.jobInfo;
        jobInfo.jobStartDate = this.currentYYYYMM;
        jobInfo.nbrSkillSurvey = "0";
        let gameStartDate = this.currentYYYYMM;
        if (+gameTemplate.gameNbrMonths !== 360){
            const nbrMonths = 360 - +gameTemplate.gameNbrMonths;
            gameStartDate = rollBackwardDate(this.currentYYYYMM, nbrMonths);
        }
        const dateObj = getCurrentDateTime();
        const dateAdded = dateObj.date;
        const dateUpdated = dateObj.date;
        this.bodyObj = {
           "user": username,
           "jobInfo": gameTemplate.jobInfo,
           "homeInfo": gameTemplate.homeInfo,
           "furnitureID": gameTemplate.furnitureID,
           "carInfo": carInfo,
           "startingCash": this.currentCash,
           "currentCash": this.currentCash,
           "currentMoodPoints": gameTemplate.currentMoodPoints,
           "startGameDate": gameStartDate,
           "currentGameDate": this.currentYYYYMM,
           "assetTable": this.assetArr,
           "expenseTable": gameTemplate.expenseTable,
           "loanTable": gameTemplate.loanTable,
           "skillSurvey": gameTemplate.skillSurvey,
           "conditionsTable": gameTemplate.conditionsTable,
           "friendList": gameTemplate.friendList,
           "spendingHistory": gameTemplate.spendingHistory,
           "moodPointHistory": gameTemplate.moodPointHistory,
           "gameNbrMonths": gameTemplate.gameNbrMonths,
           "iconTable": gameTemplate.iconTable,
           "badgesEarned": this.badgesEarnedArr,
           "prevGameMonths": this.totalPrevGameMonths.toString(),
           "prevNbrGames": this.totalNbrGames.toString(),
           "gameTemplate": gameTemplate.gameTemplateName,
           "pendingJob": {},
           "nbrMonthsNegative": "0",
           "nbrMonthsMoodNegative": "0",
           "unlockedFeatures": gameTemplate.unlockedFeatures,
           "dateAdded": dateAdded,
           "dateUpdated": dateUpdated,
       };
   }

   addExtraCreditAndBadges(assetTable){
        this.assetArr = assetTable;
        if (this.extraCreditData && this.extraCreditData.user ){
            let extraCreditArr = this.extraCreditData.extraCreditTable;
            let extraCreditObj = getExtraCreditForNewGame(extraCreditArr, this.assetArr, this.currentYYYYMM);
            this.assetArr = extraCreditObj.assetArr;
            this.currentCash += +extraCreditObj.totalCashIncrease;
            this.allExtraCreditEarned = extraCreditObj.allExercisesComplete;
        }
        if (this.badgesEarnedArr.length > 0){
            let badgesEarnedObj = getBadgesEarnedForNewGame(this.badgesEarnedArr, this.assetArr, this.currentYYYYMM);
            this.assetArr = badgesEarnedObj.assetArr;
            this.currentCash += +badgesEarnedObj.totalCashIncrease;    
        }
   }

   createNewCondition(conditionTable){
        const conditionObj={condName: "all-extra-credit-complete", conditionClass: "game"};
        conditionTable.push(conditionObj);
   }
    
    finalizeOptions() {
        this.nextProcess = "";
        const testRequired = checkIfTestComplete(this.props.accountSettings,
                            this.props.moneyMgmtTestArr );
        if (testRequired === true){
            this.nextProcess = "money-mgmt-test";
        }else{
            this.nextProcess = "game-board";
        }
        this.buildGamesCollection();
        this.removeSessionStorage();
        this.createGamesCollection();
    }

    buildGamesCollection(){
        // either change these values to 'this.' or put bodyObj back in this process....OR....
        const username = sessionStorage.getItem("username");
        const careerID = sessionStorage.getItem("careerChoice");
        const jobName = sessionStorage.getItem("careerName");
        const nbrYearsCollege = sessionStorage.getItem("jobNbrYearsCollege");
        const jobRank = sessionStorage.getItem("jobRank");
        const jobHealthInsInd = sessionStorage.getItem("jobHealthInsInd");
        const homeID = sessionStorage.getItem("homeChoice");
        const homeType = sessionStorage.getItem("homeType");
        const roommates = sessionStorage.getItem("homeRoommates");
        const bedrooms = sessionStorage.getItem("homeBedrooms");
        const furnitureID = sessionStorage.getItem("furnitureChoice");
        const carID = sessionStorage.getItem("carChoice");
        const startingCash = sessionStorage.getItem("startingCash");
        const assets = JSON.parse(sessionStorage.getItem("assetObjects", this.assetObj));
        const expenses = JSON.parse(sessionStorage.getItem("expenseObjects"))
        const loanData = JSON.parse(sessionStorage.getItem("loanDataObjects"));
        const currentYYYYMM = sessionStorage.getItem("currentYYYYMM");
        // carYear is current game year minus the yearAdj for car selected
        const yearAdj = sessionStorage.getItem("carYearAdj");
        const yearMonthVals = currentYYYYMM.split('-'); 
        const carYear = (+yearMonthVals[0] - +yearAdj).toString();
        const carAge = (+yearMonthVals[0] - carYear) * 12;
        const carType = sessionStorage.getItem("carSize");
        const skillSurvey = (sessionStorage.getItem('skillsInterestsInput')).split(",");
        const carInfo={carID: carID, carAge: carAge, carYear: carYear, carType: carType,
            carGameDate: currentYYYYMM};
        const homeInfo =  {homeID: homeID, homeType: homeType, roommates: roommates, bedrooms: bedrooms};
        const jobInfo = {careerID: careerID, jobName: jobName, healthInsInd: jobHealthInsInd, jobRank: jobRank,
            nbrYearsCollege: nbrYearsCollege, nbrSkillSurvey: "1",
            jobStartDate: currentYYYYMM};
        this.determineFriendList();
        const spendingHistory = JSON.parse((sessionStorage.getItem("spendingHistory")));
        const currentMoodPoints = sessionStorage.getItem("startingMoodPoints");
        const moodPointHistory = JSON.parse((sessionStorage.getItem("moodPointHistory")));
        const gameNbrMonths = this.startNbrGameMonths;
        this.createIconTableInfoEntry();
            
        const dateObj = getCurrentDateTime();
        const dateAdded = dateObj.date;
        const dateUpdated = dateObj.date;
        this.bodyObj = {
            "user": username,
            "jobInfo": jobInfo,
            "homeInfo": homeInfo,
            "furnitureID": furnitureID,
            "carInfo": carInfo,
            "startingCash": startingCash,
            "currentCash": startingCash,
            "currentMoodPoints": currentMoodPoints,
            "startGameDate": currentYYYYMM,
            "currentGameDate": currentYYYYMM,
            "assetTable": assets,
            "expenseTable": expenses,
            "loanTable": loanData,
            "skillSurvey": skillSurvey,
            "conditionsTable": [],
            "friendList": this.friendArr,
            "spendingHistory": spendingHistory,
            "moodPointHistory": moodPointHistory,
            "gameNbrMonths": gameNbrMonths,
            "iconTable": this.iconTable,
            "badgesEarned": this.badgesEarnedArr,
            "prevGameMonths": this.totalPrevGameMonths.toString(),
            "prevNbrGames": this.totalNbrGames.toString(),
            "gameTemplate": "none",
            "pendingJob": {},
            "nbrMonthsNegative": "0",
            "nbrMonthsMoodNegative": "0",
            "unlockedFeatures": [],
            "dateAdded": dateAdded,
            "dateUpdated": dateUpdated,
        };
       
        this.loadConditions();
        let conditionClasses = [];
        this.bodyObj.conditionsTable = 
            setupConditionsUpdate(this.bodyObj, this.conditionsList, conditionClasses);
        if (this.allExtraCreditEarned === true){
            this.createNewCondition(this.bodyObj.conditionsTable);
        }
    }

    setExtraCreditEarned(){
        //  this is called by the final_confirm_modal if all extra credit exercises have been completed.
        this.allExtraCreditEarned = true;
    }
        
    
    determineFriendList(){
        let dataObj =  DataObjectsTemplate.find(elem => elem.dataType === "friendList");
       
        this.friendArr = [];
        let friendObj = JSON.parse(JSON.stringify(dataObj.friendInfo));
        friendObj.name = "Charlie";
        this.friendArr.push(friendObj);
        friendObj = JSON.parse(JSON.stringify(dataObj.friendInfo));
        friendObj.name = "Cameron";
        this.friendArr.push(friendObj);
        friendObj = JSON.parse(JSON.stringify(dataObj.friendInfo));
        friendObj.name = "Jennifer";
        this.friendArr.push(friendObj);
        friendObj = JSON.parse(JSON.stringify(dataObj.friendInfo));
        friendObj.name = "Cindy";
        this.friendArr.push(friendObj);
    }

    createIconTableInfoEntry(){
        this.iconTable = [];
        let infoIcon = { iconName: "gameBasicHelp", iconCategory: "information", 
            className: "small_sign_thumbnail_img information-sign-position",
            imageSrc: "gameHelp.png", nbrMonths: -1, firstTime: true};
        this.iconTable.push(infoIcon);
    }
    
    removeSessionStorage(){
        sessionStorage.removeItem("careerChoice");
        sessionStorage.removeItem("homeChoice");
        sessionStorage.removeItem("furnitureChoice");
        sessionStorage.removeItem("carChoice");
        sessionStorage.removeItem("startingCash");
        sessionStorage.removeItem("assetObjects");
        sessionStorage.removeItem("expenseObjects");
        sessionStorage.removeItem("loanDataObjects");
        sessionStorage.removeItem('skillsInterestsInput');
    }

    createGamesCollection(){    
        const funcName = "saveGameSelections";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {
                method:'post',
                headers: this.state.headers,
                body: JSON.stringify(this.bodyObj)
                })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.props.setInfoRedux(output.body.gameData, "gameData");
                        sessionStorage.setItem("gameID", output.body.gameData._id);
                        this.props.setInfoRedux(true, "gameExists");
                        this.afterGameAdded(output.body.gameData._id);
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.bodyObj};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
    }

    afterGameAdded(gameID){
        const testRequired = checkIfTestComplete(this.props.accountSettings,
            this.props.moneyMgmtTestArr );
        if (testRequired === true){
            this.nextProcess = "money-mgmt-test";
        }else{
            this.nextProcess = "game-board";
        }
        const carSize = sessionStorage.getItem("carSize");
        if (+carSize === 50){
            // creating gamePurchase for bicycle
            this.createGamePurchase(gameID);
        }else{                       
            this.onNavigate(this.nextProcess);
        }
    }

    createGamePurchase(gameID){
        const currentYYYYMM = sessionStorage.getItem("currentYYYYMM");
        const bicycleCost = ConfigFile.gameStartItems.bicycleCost * -1;
        const imageDir = "item-1Thousand-noFriend";
        const gamePurchaseArr = updateGamePurchaseArr("bicycle", imageDir, 
            bicycleCost, currentYYYYMM, [])
        this.gamePurchaseObj = {gameID: gameID, purchaseTable: gamePurchaseArr};
        const funcName = "updateGamePurchases";
        const urlParm = "?gameID=" + gameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        fetch(uri,
            {
                method: 'PUT', 
                headers: this.state.headers,
                body: JSON.stringify(this.gamePurchaseObj)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (output.statusCode === 200){ 
                        this.props.setInfoRedux(output.body, "gamePurchases");
                        this.onNavigate(this.nextProcess);
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.gamePurchasesObj};
                        this.processErrorReturn(errorObj);
                    }
                });
            }
        });
    }

    restoreGame(gameID){
        const funcName = "restoreGameRecord";
        const urlParm = "?gameID=" + gameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {
                method:'post',
                headers: this.state.headers,
                body: JSON.stringify(this.bodyObj)
                })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        //  process was successful but need to return the gamedata....
                        this.props.setInfoRedux(output.body.gameData, "gameData");
                        sessionStorage.setItem("gameID", output.body.gameData._id);
                        this.props.setInfoRedux(true, "gameExists");
                        const gameData = output.body.gameData;
                        this.restoreTimeWizard = false;
                        const oldGameID = gameID;
                        const newGameID = gameData._id;
                        const gameDate = gameData.currentGameDate;
                        const timeWizardInfo = output.body.timeWizardInfo;
                        if (timeWizardInfo && timeWizardInfo.gameID){
                            this.timeWizardObj = timeWizardInfo;
                            this.timeWizardObj.gameID = newGameID;
                            this.restoreTimeWizard = true;
                        }
                        this.restoreRelatedGameData(oldGameID, gameData.unlockedFeatures, newGameID, gameDate);
                        
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.bodyObj};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
    }

    restoreRelatedGameData(oldGameID, unlockedFeatures, newGameID, gameDate){
        let funStuffRestored = false;
        let savingsRestored = false;
        let creditCardRestored = false;
        let gameInvestmentsRestored = false;
        let timeWizardRestored = false;
        this.dummyObj = {};
        if (this.restoreTimeWizard === true){
            timeWizardRestored = true;
            this.saveTimeWizard();
        }
        for (let i=0; i<unlockedFeatures.length; i++){
            let unlockedFeature = unlockedFeatures[i];
            if (unlockedFeature.featureName === "funStuff"){
                funStuffRestored = true;
                this.restoreFunStuff(oldGameID, newGameID);
            }
            if (unlockedFeature.featureName === "moneyBuilder" ){
                savingsRestored = true;
                this.restoreSavings(oldGameID, newGameID, gameDate);
            }
            if (unlockedFeature.featureName === "creditCard"){
                creditCardRestored = true;
                this.restoreCreditCard(oldGameID, newGameID);
            }
            if (unlockedFeature.featureName === "moneyBuilder" &&
                unlockedFeature.level >= 3 ){
                gameInvestmentsRestored = true;
                this.restoreGameInvestments(oldGameID, newGameID);
            }
            if (funStuffRestored === false){
                this.setState({funStuffRestored: true});
            }
            if (savingsRestored === false){
                this.setState({savingsRestored: true});
            }
            if (creditCardRestored === false){
                this.setState({creditCardRestored: true});
            }
            if (timeWizardRestored === false){
                this.setState({timeWizardRestored: true});
            }
            if (gameInvestmentsRestored === false){
                this.setState({gameInvestmentsRestored: true});
            }
        }
        this.restoreGamePurchases(oldGameID, newGameID);
        this.restoreGameActivityTracker(oldGameID, newGameID);
        if (this.state.timeout) clearTimeout(this.state.timeout);
            this.state.timeout = setTimeout(() => {
                this.onNavigate("game-board");
        }, 1000);
    }

    saveTimeWizard(){
        const dateObj = getCurrentDateTime();
        this.timeWizardObj.dateAdded = dateObj.date;
        this.timeWizardObj.dateUpdated = dateObj.date;
        const funcName = "updateTimeWizard";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'PUT', headers: this.state.headers, 
            body: JSON.stringify(this.timeWizardObj)})
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        // "update of time Wizard was successful";
                        this.props.setInfoRedux(output.body, "timeWizardInfo");
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, 
                            errorObject: this.timeWizardObj};
                        this.processErrorReturn(errorObj);
                    }
                });
                }
            });
    }

    restoreCreditCard(oldGameID, newGameID){
        const funcName = "restoreCreditCard";
        const urlParm = "?oldGameID=" + oldGameID + "&newGameID=" + newGameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        fetch(uri,
            {
                method: 'PUT', 
                headers: this.state.headers,
                body: JSON.stringify(this.dummyObj)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (output.statusCode === 200){ 
                         this.props.setInfoRedux(output.body, "creditCardInfo");
                    }else{
                        if (output.statusCode === 250){
                        //  there is no credit card to restore
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: urlParm};
                            this.processErrorReturn(errorObj);
                        }
                    }
                });
            }
        });
    }

    restoreSavings(oldGameID, newGameID, gameDate){
        const funcName = "restoreSavingsAmts";
        const urlParm = "?oldGameID=" + oldGameID + "&newGameID=" + newGameID + "&gameDate=" +
            gameDate;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'PUT', headers: this.state.headers, 
            body: JSON.stringify(this.dummyObj)})
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.props.setInfoRedux(output.body, "savingsInfo");
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: urlParm};
                        this.processErrorReturn(errorObj);
                    }
            });
            }
        });
    }
    
    restoreFunStuff(oldGameID, newGameID){
        const funcName = "restoreFunStuff";
        const urlParm = "?oldGameID=" + oldGameID + "&newGameID=" + newGameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {
                method: 'PUT', headers: this.state.headers,
                body: JSON.stringify(this.dummyObj)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.props.setInfoRedux(output.body, "funStuffInfo");
                    }else{
                        if (statusCode === 250){
                            // there is no funStuff record to restore
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: urlParm};
                            this.processErrorReturn(errorObj);
                        }
                    }
                });
            }
        });
    }

    restoreGameInvestments(oldGameID, newGameID){
        const funcName = "restoreGameInvestments";
        const urlParm = "?oldGameID=" + oldGameID + "&newGameID=" + newGameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
    
        fetch(uri,
            {
                method: 'PUT', 
                headers: this.state.headers,
                body: JSON.stringify(this.dummyObj)
            })
            .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (output.statusCode === 200){ 
                    //  update of gameInvestments was successful
                     this.props.setInfoRedux(true, "refreshInvestments");
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: urlParm};
                    this.processErrorReturn(errorObj);
                }
            });
            }
        });
    }

    restoreGamePurchases(oldGameID, newGameID){
        const funcName = "restoreGamePurchases";
        const urlParm = "?oldGameID=" + oldGameID + "&newGameID=" + newGameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        fetch(uri,
            {
                method: 'PUT', 
                headers: this.state.headers,
                body: JSON.stringify(this.dummyObj)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (output.statusCode === 200){ 
                        //  update of gamePurchases was successful
                        this.props.setInfoRedux(output.body, "gamePurchases");
                    }else{
                        if (output.statusCode === 250){
                            //  no game purchases record found to restore
                        
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: urlParm};
                            this.processErrorReturn(errorObj);
                        }
                    }
                });
                }
            });
    }

    restoreGameActivityTracker(oldGameID, newGameID){
        const funcName = "restoreGameActivity";
        const urlParm = "?oldGameID=" + oldGameID + "&newGameID=" + newGameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            {method:'put', 
                headers: this.state.headers,
                body: JSON.stringify(this.dummyObj)})
                .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            // restore of activity tracker was successful
                            // activityTracker is stored in redux but only for a single category
                        }else{
                            if (statusCode === 250){
                                //  there is no activity tracker to restore
                            }else{
                                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                    status: statusCode, message: output.body.message, errorObject: urlParm};
                                this.processErrorReturn(errorObj);
                            }
                        }
                    });
                };
        });
    }

    checkUserInput()
    {   let inputArr = this.state.inputArr;
        if (sessionStorage.getItem('skillsInterestsInput')) inputArr[0].completed = true;
        if (sessionStorage.getItem('careerChoice')) inputArr[1].completed = true;
        if (sessionStorage.getItem('homeChoice')) inputArr[2].completed = true;
        if (sessionStorage.getItem('furnitureChoice')) inputArr[3].completed = true;
        if (sessionStorage.getItem('carChoice')) inputArr[4].completed = true;
        if (this._isMounted === true){
            this.setState({inputArr: inputArr});
        }
    }

    goToHomePage(){
        this.onNavigate("");
    }
    
    processErrorReturn(errorObj){
        this.addRecordToLogfile(errorObj);
        if (!errorObj.silentAlert || errorObj.silentAlert === false){
            alert ("Uh oh!  Something unexpected has occurred " +
                "error has been logged and will be addressed. " +
                "For now click OK, then return to the process " +
                "where you were and try again.");
        }      
        this.onNavigate("");
    }

    addRecordToLogfile(errorObj){
        if (errorObj.status === 250){
            errorObj.message = "No record found";
        }
        if (!errorObj.errorObject){
            errorObj.errorObject = {};
        }
        const logFileBody =  {
            mainProcess: "game",
            subProcess: errorObj.subProcess,
            function: errorObj.function,
            status: errorObj.status,
            message: errorObj.message,
            errorObj: errorObj.errorObject
        }
        console.log("logFileBody is: ", logFileBody)
        const urlParm = "";
        const funcName = "saveLogFile";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'POST',
                headers: this.state.headers,
                body: JSON.stringify(logFileBody)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            console.log("write to logfile was successful");
                            this.logFileWriteComplete = true;
                        }else{
                            console.log("Response from save log file not valid!" +
                            " status is: ", output.statusCode,
                            " message is: ", output.body);
                           alert ("Response from save log file not valid!");
                           
                        };
                   
                });
            }
        });
      
    }
}

export default  connect(mapStateToProps, mapDispatchToProps)(
    withRouterCompat(GettingStartedDetailed));

